import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ECIs, Margin, POs, Requirement, Submission } from './DashboardModel';
import { MyResponsiveBar } from './Chart';
import { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { useLocation } from 'react-router-dom';

export interface Fields {
    ReqData:Requirement[] | [],
    SubData:Submission[] | [],
    ECIData:ECIs[] | [],
    POData:POs[] | [],
    MarginData:Margin[] | [],
    which:string,
    tabOf:string,
};

const initialState:any={ReqSub:{AA:true,AB:false,BA:true,BB:false},EciPo:{AA:true,AB:false,BA:true,BB:false},Margin:{AA:true,AB:false}};

const DataTableView = ({ReqData,SubData,ECIData,POData,MarginData,which,tabOf}:Fields) => {
    const TableName = "Recent Data";
    const subTil="dsdbdsbf fdvbd fbfdb fdb";
    
    const ReqTableName=()=><h4><b>{tabOf==="branch"?"Branch":"Company"} Requirements</b></h4>;
    const SubTableName=()=><h4><b>{tabOf==="branch"?"Branch":"Company"} Submissions</b></h4>;
    const ECITableName=()=><h4><b>{tabOf==="branch"?"Branch":"Company"} ECI</b></h4>;
    const POTableName=()=><h4><b>{tabOf==="branch"?"Branch":"Company"} PO</b></h4>;
    const MarginTableName=()=><h4><b>{tabOf==="branch"?"Branch":"Company"} Margin</b></h4>;

    const [tabBar,setTabBar]=useState(initialState);

    const location=useLocation();

    const rowClass = (data:any) => {
        return {
            'bg-gray-100 font-semibold': data.branchName==="Day Total" || data.branchName==="Week Total" || data.branchName==="Quarter Total" || data.branchName==="Month Total",
        };
    };

    // console.log(Object.keys(ReqData[0]));

    // title={TableName} subTitle={subTil}
    // useEffect(()=>{
    //     setTabBar(initialState);
    // },[location.pathname]);

    if(which==="ReqSub"){
        return <Card className='mt-1'>
            <div className='grid'>
                <div className='sm:border-bottom-3 md:border-bottom-3 col-12 md:col-12 lg:col lg:border-none'>
                    <div className='flex align-content-center justify-content-between p-3 border-1 surface-border surface-50'>
                        <ReqTableName />
                        <div className='flex gap-4'>
                            <Button icon="pi pi-table" label="Tabel" className='h-2rem' onClick={()=>setTabBar({...tabBar,ReqSub:{...tabBar.ReqSub,AA:true,AB:false}})}/>
                            <Button label="Graph" icon="pi pi-chart-bar" className='h-2rem' onClick={()=>setTabBar({...tabBar,ReqSub:{...tabBar.ReqSub,AA:false,AB:true}})}/>
                        </div>
                    </div>
                    {ReqData.length>0 && tabBar.ReqSub.AA && <DataTable value={ReqData} rowClassName={rowClass} tableStyle={{ minWidth: '100%'}} showGridlines>
                        <Column field={"branchName"} header={tabOf==="branch"?"Branch Name":"Company Name"} sortable ></Column>
                        <Column field={"totalRequirement"} header={"TR"} sortable></Column>
                        <Column field={"totalAllocation"} header={"TA"} sortable></Column>
                        <Column field={"totalServices"} header={"TS"} sortable></Column>
                        <Column field={"serving"} header={"TSub"} sortable></Column>
                    </DataTable>}
                    { ReqData.length>0 && tabBar.ReqSub.AB && <MyResponsiveBar data={ReqData} keys={["Total Requirement","Total Allocation","Total Served","Total Submission"]} type={"Req"} Of={tabOf==="branch"?"Branch":"Company"}/>}
                </div>
                <div className='col-12 md:col-12 lg:col'>
                    <div className='flex align-content-center justify-content-between p-3 border-1 surface-border surface-50'>
                        <SubTableName />
                        <div className='flex gap-4'>
                            <Button icon="pi pi-table" label="Tabel" className='h-2rem' onClick={()=>setTabBar({...tabBar,ReqSub:{...tabBar.ReqSub,BA:true,BB:false}})}/>
                            <Button label="Graph" icon="pi pi-chart-bar" className='h-2rem' onClick={()=>setTabBar({...tabBar,ReqSub:{...tabBar.ReqSub,BA:false,BB:true}})}/>
                        </div>
                    </div>
                    {SubData.length>0 && tabBar.ReqSub.BA && <DataTable value={SubData} rowClassName={rowClass} tableStyle={{ minWidth: '100%'}} showGridlines>
                        <Column field={"branchName"} header={tabOf==="branch"?"Branch Name":"Company Name"} sortable></Column>
                        <Column field={"totalSubmission"} header={"TS"} sortable></Column>
                        <Column field={"totalSalesRejected"} header={"TS R"} sortable></Column>
                        <Column field={"totalPVRejected"} header={"TPV R"} sortable></Column>
                        <Column field={"totalEndClientSubmission"} header={"TEC S"} sortable></Column>
                    </DataTable>}
                    { SubData.length>0 && tabBar.ReqSub.BB && <MyResponsiveBar data={SubData} keys={["Total Submission","Total Sales Rejected","Total PV Rejected","Total End Client Submission"]} type={"Sub"} Of={tabOf==="branch"?"Branch":"Company"}/>}
                </div>
            </div>
        </Card>
    }
    
    if(which==="EciPo"){
        return <Card className='mt-5'>
            <div className='grid'>
                <div className='sm:border-bottom-3 md:border-bottom-3 col-12 md:col-12 lg:col lg:border-none'>
                    <div className='flex align-content-center justify-content-between p-3 border-1 surface-border surface-50'>
                        <ECITableName />
                        <div className='flex gap-4'>
                            <Button icon="pi pi-table" label="Tabel" className='h-2rem' onClick={()=>setTabBar({...tabBar,EciPo:{...tabBar.EciPo,AA:true,AB:false}})}/>
                            <Button label="Graph" icon="pi pi-chart-bar" className='h-2rem' onClick={()=>setTabBar({...tabBar,EciPo:{...tabBar.EciPo,AA:false,AB:true}})}/>
                        </div>
                    </div>
                    { ECIData.length>0 && tabBar.EciPo.AA && <DataTable value={ECIData} rowClassName={rowClass} tableStyle={{ minWidth: '100%'}} showGridlines>
                        <Column field={"branchName"} header={tabOf==="branch"?"Branch Name":"Company Name"} sortable></Column>
                        <Column field={"totalECI"} header={"T ECI"} sortable></Column>
                        <Column field={"totalBackoutECI"} header={"TB ECI"} sortable></Column>
                        <Column field={"totalConfirmedECI"} header={"TC ECI"} sortable></Column>
                        <Column field={"totalRescheduledECI"} header={"TR ECI"} sortable></Column>
                    </DataTable>}
                    { ECIData.length>0 && tabBar.EciPo.AB && <MyResponsiveBar data={ECIData} keys={["Total ECI","Total Backout ECI","Total Confirmed ECI","Total Rescheduled ECI"]} type={"ECI"} Of={tabOf==="branch"?"Branch":"Company"}/>}
                </div>
                <div className='col-12 md:col-12 lg:col'>
                    <div className='flex align-content-center justify-content-between p-3 border-1 surface-border surface-50'>
                        <POTableName />
                        <div className='flex gap-4'>
                            <Button icon="pi pi-table" label="Tabel" className='h-2rem' onClick={()=>setTabBar({...tabBar,EciPo:{...tabBar.EciPo,BA:true,BB:false}})}/>
                            <Button label="Graph" icon="pi pi-chart-bar" className='h-2rem' onClick={()=>setTabBar({...tabBar,EciPo:{...tabBar.EciPo,BA:false,BB:true}})}/>
                        </div>
                    </div>
                    { POData.length>0 && tabBar.EciPo.BA && <DataTable value={POData} rowClassName={rowClass} tableStyle={{ minWidth: '100%'}} showGridlines>
                        <Column field={"branchName"} header={tabOf==="branch"?"Branch Name":"Company Name"} sortable></Column>
                        <Column field={"totalPO"} header={"TPO"} sortable></Column>
                        <Column field={"totalRunningPO"} header={"TR PO"} sortable></Column>
                        <Column field={"totalEndedPO"} header={"TE PO"} sortable></Column>
                        <Column field={"totalFizzledPO"} header={"TF PO"} sortable></Column>
                    </DataTable>}
                    { POData.length>0 && tabBar.EciPo.BB && <MyResponsiveBar data={POData} keys={["Total PO","Total Running PO","Total Ended PO","Total Fizzled PO"]} type={"PO"} Of={tabOf==="branch"?"Branch":"Company"}/>}
                </div>
            </div>
        </Card>
    }

    if(which==="Margin"){
        return <Card className='mt-5'>
            <div className='sm:border-bottom-3 md:border-bottom-3 lg:border-none'>
                <div className='flex align-content-center justify-content-between p-3 border-1 surface-border surface-50'>
                    <MarginTableName />
                    <div className='flex gap-4'>
                        <Button icon="pi pi-table" label="Tabel" className='h-2rem' onClick={()=>setTabBar({...tabBar,Margin:{...tabBar.Margin,AA:true,AB:false}})}/>
                        <Button label="Graph" icon="pi pi-chart-bar" className='h-2rem' onClick={()=>setTabBar({...tabBar,Margin:{...tabBar.Margin,AA:false,AB:true}})}/>
                    </div>
                </div>
                { MarginData.length>0 && tabBar.Margin.AA && <DataTable value={MarginData} rowClassName={rowClass} tableStyle={{ minWidth: '100%'}} showGridlines>
                        <Column field={"branchName"} header={tabOf==="branch"?"Branch Name":"Company Name"} sortable></Column>
                        <Column field={"totalMargin"} header={"TM"} sortable></Column>
                        <Column field={"totalRunningMargin"} header={"TRM"} sortable></Column>
                        <Column field={"totalEndedMargin"} header={"TEM"} sortable></Column>
                        <Column field={"totalFizzledMargin"} header={"TFM"} sortable></Column>
                    </DataTable>}
                { MarginData.length>0 && tabBar.Margin.AB && <MyResponsiveBar data={MarginData} keys={["Total Margin","Total Running Margin","Total Ended Margin","Total Fizzled Margin"]} type={"Margin"} Of={tabOf==="branch"?"Branch":"Company"}/>}
            </div>
        </Card>
    }

    return <Card title={"No Data Found"}></Card>
};

export default DataTableView;